import {
  BooleanField,
  BooleanInput,
  Create,
  Datagrid,
  Edit,
  FormTab,
  List,
  NumberInput,
  required,
  SearchInput,
  SelectInput,
  TextField,
} from "react-admin";
import { useCommonLabels } from "../i18n/hooks";
import { FormSection } from "../ui/forms/FormSection";
import {
  ActionLabelLangFields,
  SubtitleLangFields,
  TitleLangFields,
} from "../ui/forms/langFields";
import { LangTabbedForm } from "../ui/forms/LangTabbedForm";

const filters = [<SearchInput key="q" source="q" alwaysOn />];

const SECTION_KEYS = [
  { id: "daily_cards_header", name: "Заголовок карточек" },
  { id: "emotions_tracker", name: "Трекер эмоций" },
  { id: "survey", name: "Карточка опроса" },
  { id: "breathing", name: "Дыхательные упражнения" },
  { id: "music", name: "Музыка" },
  { id: "helpers", name: "Другие помощники" },
  { id: "more", name: "Ещё" },
  { id: "news", name: "Новости" },
];

const PhHomeSectionForm = () => {
  const c = useCommonLabels();
  return (
    <LangTabbedForm>
      <FormTab label="Общее">
        <FormSection title="Секция главной">
          <SelectInput
            source="SectionKey"
            label="Ключ секции"
            choices={SECTION_KEYS}
            validate={required()}
            fullWidth
          />
          <NumberInput source="SortOrder" label="Порядок" defaultValue={0} fullWidth />
          <BooleanInput source="Active" label={c.active} defaultValue />
        </FormSection>
      </FormTab>
      <FormTab label="🇦🇿 AZ">
        <TitleLangFields lang="AZ" titleRequired />
        <SubtitleLangFields lang="AZ" />
        <ActionLabelLangFields lang="AZ" />
      </FormTab>
      <FormTab label="🇷🇺 RU">
        <TitleLangFields lang="RU" titleRequired />
        <SubtitleLangFields lang="RU" />
        <ActionLabelLangFields lang="RU" />
      </FormTab>
      <FormTab label="🇬🇧 EN">
        <TitleLangFields lang="EN" titleRequired />
        <SubtitleLangFields lang="EN" />
        <ActionLabelLangFields lang="EN" />
      </FormTab>
    </LangTabbedForm>
  );
};

export const PhHomeSectionList = () => {
  const c = useCommonLabels();
  return (
    <List filters={filters} sort={{ field: "SortOrder", order: "DESC" }}>
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <TextField source="SectionKey" label="Ключ" />
        <TextField source="TitleRU" label="Заголовок" />
        <TextField source="ActionLabelRU" label="Кнопка" />
        <BooleanField source="Active" label={c.status} />
      </Datagrid>
    </List>
  );
};

export const PhHomeSectionEdit = () => (
  <Edit mutationMode="pessimistic">
    <PhHomeSectionForm />
  </Edit>
);

export const PhHomeSectionCreate = () => (
  <Create>
    <PhHomeSectionForm />
  </Create>
);
